import { useAuthzContext } from './AuthzContextProvider'
import { resolveAccess } from './resolveAccess'
import { resolveAvailability } from './resolveAvailability'
import { useAvailabilityInputs } from './useAvailabilityInputs'
import { useRoleAccessContext } from './useRoleAccessContext'
import type { AvailabilityRule } from './availability'
import type { AccessRule } from './routeRegistry'

export const useIsAllowed = (rule: { availability: AvailabilityRule; access: AccessRule }): boolean => {
  const availability = resolveAvailability(rule.availability, useAvailabilityInputs())
  return resolveAccess(rule.access, availability, useAuthzContext(), useRoleAccessContext()) === 'allowed'
}
